import { render, staticRenderFns } from "./EventRegistrationTickets.vue?vue&type=template&id=4ab6e88f&"
import script from "./EventRegistrationTicketsVue.ts?vue&type=script&lang=ts&"
export * from "./EventRegistrationTicketsVue.ts?vue&type=script&lang=ts&"
import style0 from "./EventRegistrationTickets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports